<template>
	<div>
		<div id="app">
			<div v-if="isChrome">
				{{ stateSync }}
				<router-view v-if="isChrome" />
			</div>
			<Unsupportedbrowser v-else />
		</div>
		<Internet />
		<LoginModals />
	</div>
</template>

<script>
import Internet from "./components/fixedcomponents/Internet.vue";
import LoginModals from "./components/modals/LoginToastModals.vue";
import Unsupportedbrowser from "./components/Unsupportedbrowser.vue";
export default {
	name: "App",
	props: {
		isChrome: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		Internet,
		LoginModals,
		Unsupportedbrowser,
	},
	data() {
		return {};
	},
	computed: {
		stateSync() {
			let stt = this.$store.state;
			localStorage.setItem("simpCandidState", JSON.stringify(stt));
			return "";
		},
	},
	created() {
		if (this.isChrome) {
			let savedstate = localStorage.getItem("simpCandidState");
			if (savedstate != null) {
				this.$store.replaceState(JSON.parse(savedstate));
			}
		}
	},

	methods: {
		detectBrowser() {
			const { userAgent } = navigator;

			if (navigator.brave) return "Brave"; // Brave
			if (userAgent.includes("Edg/")) return "Edge"; // Edge
			if (userAgent.includes("OPR/")) return "Opera"; // Opera
			if (userAgent.includes("Vivaldi")) return "Vivaldi"; // Vivaldi
			if (userAgent.includes("SamsungBrowser")) return "Samsung"; // Samsung Internet
			if (userAgent.includes("YaBrowser")) return "Yandex"; // Yandex
			if (userAgent.includes("Firefox/")) return "Firefox"; // Firefox
			if (userAgent.includes("Safari/") && !userAgent.includes("Chrome/"))
				return "Safari"; // Safari
			if (userAgent.includes("Chrome/")) return "Chrome"; // Chrome (last, after excluding others)

			return "Unknown"; // fallback
		},

		fnBrowserDetect() {
			const browser = this.detectBrowser();
			const isChrome = browser === "Chrome";
			return  isChrome;
		},
	},
};
</script>
